module.exports = __webpack_public_path__ + "img/home-splash-drawing.bf9a7b69.svg";